import React from "react";
import PropTypes from "prop-types";
import { Typography } from "@material-ui/core";
import SquareChip from "../../../../SquareChip";
import LPREye from "../LPREye";
import DetailsValueRow from "../DetailsValueRow";

const LPRImageOnlyDetails = ({ lprId, hasImages, onLPRSave }) => {
  return (
    <>
      <DetailsValueRow title="Status">
        <Typography variant="h6" data-value="">{""}</Typography>
      </DetailsValueRow>
      <DetailsValueRow title="Credential" thin={true}>
        <Typography>{""}</Typography>
      </DetailsValueRow>
      <DetailsValueRow title="Plate" thin={true}>
        <span>
          <SquareChip mode="warning" text="No Plate Found" />
          {hasImages && (
            <LPREye lprPlateText={null} lprID={lprId} onClose={onLPRSave} />
          )}
        </span>
      </DetailsValueRow>
    </>
  );
};

LPRImageOnlyDetails.defaultProps = {
  lprId: null,
  hasImages: false,
  onLPRSave: () => {}
};

LPRImageOnlyDetails.propTypes = {
  lprId: PropTypes.number,
  hasImages: PropTypes.bool,
  onLPRSave: PropTypes.func
};

export default LPRImageOnlyDetails;
